<template>
  <div class="editor-container" id="music">
    <div class="fixed">
      <EditorMenu />
      <GlassPreview>
        <div class="song-container">
          <div class="song">
            <span class="name">{{ song }}</span>
            <span class="interpret">{{ interpret }}</span>
          </div>
          <span class="like"></span>
        </div>
        <div class="timeline-container">
          <span class="timeline">
            <span class="cursor" :style="{ left: `${range}%` }"></span>
          </span>
          <span v-if="product.attributes.actualTime" class="actual-time">{{
            product.attributes.actualTime
          }}</span>
          <span v-if="product.attributes.endTime" class="end-time">{{
            product.attributes.endTime
          }}</span>
        </div>
        <div class="control-container">
          <span class="random"></span>
          <span class="prev"></span>
          <span class="play" :class="{ play: !showQR, qr: showQR }"></span>
          <span class="next"></span>
          <span class="loop"></span>
        </div>
      </GlassPreview>
    </div>
    <div class="product-fields">
       <!-- Sold -->
       <SoldCapacity v-if="soldCapacity"/>
       <!-- Editor -->
      <div class="form-fields">
        <ImageHandler />
        <MusicFields />
        <GlobalAttributes />
        <AddToCart />
      </div>
      <Loader />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AddToCart from "./AddToCart";
import useProduct from "../useProduct";
import ImageHandler from "./ImageHandler";
import ProductServices from "./../../../packages/views/product-service/Services";
import Loader from "../../../packages/views/loader/Loader";
import GlobalAttributes from "./attributes/GlobalAttributes";
import MusicFields from "./attributes/MusicFields";
import useMusic from "../useMusic";
import GlassPreview from "./glass-preview/Base";
import EditorMenu from "./EditorMenu.vue";
import SoldCapacity from "./SoldCapacity.vue";

export default {
  components: {
    ProductServices,
    Loader,
    ImageHandler,
    AddToCart,
    GlobalAttributes,
    MusicFields,
    GlassPreview,
    EditorMenu,
    SoldCapacity,
  },
  computed: {
    ...mapGetters({
      product: "product/getProduct",
      range: "product/getRange",
      showQR: "product/getShowQR",
      soldCapacity: 'product/getSoldCapacity'
    }),
  },
  setup() {
    const { imageUrl, hasElement } = useProduct();
    const { song, interpret, actualTime, endTime } = useMusic();

    return {
      hasElement,
      imageUrl,
      song,
      interpret,
      actualTime,
      endTime,
    };
  },
};
</script>
